import { formatNumber } from 'utils/formatter';
import React from 'react';

export const YieldComment = ({
  className,
  title,
  requiredYield,
  goHowToIncreaseAccumulationAmount,
}: {
  className: string;
  title: string;
  requiredYield: number | null;
  goHowToIncreaseAccumulationAmount: () => void;
}): React.ReactElement => {
  const comment: string | null = (() => {
    if (requiredYield === 0 || requiredYield === null) {
      return null;
    }
    if (requiredYield < 10) {
      return `「${title}」を達成するには、保有資産を${formatNumber(
        requiredYield,
        { numberOfDecimal: 1 }
      )}％以上の利回りで運用することが必要です。`;
    }
    if (requiredYield < 20) {
      return `「${title}」を達成するには、保有資産を${formatNumber(
        requiredYield,
        { numberOfDecimal: 1 }
      )}％以上の利回りで運用することが必要です。リスクの大きな資産への投資はリターンを大きく得られる可能性がある一方、逆に大きく損失する可能性もあります。過剰なリスクを取りすぎないようご注意ください。`;
    }
    return `「${title}」を達成するには、保有資産を${formatNumber(
      requiredYield,
      { numberOfDecimal: 1 }
    )}％以上の利回りで運用することが必要です。この目標はリスクが大きいようです。目標時期を伸ばしたり、目標金額を下げるとリスクを下げることができます。リスクの大きな資産への投資はリターンを大きく得られる可能性がある一方、逆に大きく損失する可能性もあります。過剰なリスクを取りすぎないようご注意ください。`;
  })();

  return (
    <>
      {requiredYield !== 0 && requiredYield !== null && (
        <div
          className={`text-bluegray-700 text-sm ${className ? className : ''}`}>
          {comment}
        </div>
      )}
      <div
        id="target_increase"
        className="flex fle-row mt-2 ml-auto text-blue-700 items-center cursor-pointer"
        onClick={goHowToIncreaseAccumulationAmount}>
        <div className="text-sm">つみたて金額を増やすには</div>
        <div className="ml-2 icon-help_outline"></div>
      </div>
    </>
  );
};
